// extracted by mini-css-extract-plugin
module.exports = {"tabsBottomBoder":"DocumentLibraryTabs_tabsBottomBoder__4tyJu"};